import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import Header from "@/components/Header";
import { Building2, LogOut, Plus, UserRound, X } from "lucide-react";
import { clearAuthSession, getAuthSession } from "@/lib/supabaseAuth";

const MiPerfil = () => {
  const navigate = useNavigate();
  const session = getAuthSession();
  const metadata = session?.user?.user_metadata || {};

  const userName = useMemo(
    () =>
      metadata.nombre ||
      metadata.full_name ||
      metadata.name ||
      session?.user?.email ||
      "Usuario Tulocalmx",
    [metadata, session?.user?.email]
  );

  if (!session?.access_token) {
    navigate("/iniciar-sesion?next=/mi-perfil");
    return null;
  }

  const handleLogout = () => {
    const shouldLogout = window.confirm("Realmente quieres cerrar sesion?");
    if (!shouldLogout) return;

    clearAuthSession();
    navigate("/");
  };

  return (
    <>
      <Header />
      <main className="min-h-screen bg-slate-50 px-4 py-24">
        <section className="relative mx-auto max-w-4xl rounded-xl border border-slate-200 bg-white p-6 pr-14 shadow-sm">
          <button
            type="button"
            onClick={() => navigate("/")}
            aria-label="Ir al inicio"
            className="absolute right-4 top-4 flex h-9 w-9 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-500 shadow-sm transition hover:bg-slate-50 hover:text-slate-900"
          >
            <X className="h-5 w-5" />
          </button>

          <p className="text-xs font-bold uppercase tracking-wide text-slate-500">
            Mi cuenta
          </p>
          <h1 className="mt-2 text-2xl font-black text-slate-950 sm:text-3xl">
            Hola, {userName}
          </h1>
          <p className="mt-2 text-sm leading-6 text-slate-600">
            Administra tu cuenta, revisa tus propiedades o publica una nueva.
          </p>

          <div className="mt-6 grid gap-3 sm:grid-cols-2">
            <button
              type="button"
              onClick={() => navigate("/mis-propiedades")}
              className="flex items-center gap-3 rounded-lg border border-slate-200 bg-white p-4 text-left shadow-sm transition hover:border-[#0056D2] hover:bg-slate-50"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-blue-50 text-[#0056D2]">
                <Building2 className="h-5 w-5" />
              </span>
              <span>
                <span className="block font-bold text-slate-950">
                  Mis propiedades
                </span>
                <span className="text-sm text-slate-600">
                  Ver y administrar publicaciones.
                </span>
              </span>
            </button>

            <button
              type="button"
              onClick={() => navigate("/registro?plan=gratis")}
              className="flex items-center gap-3 rounded-lg border border-slate-200 bg-white p-4 text-left shadow-sm transition hover:border-[#F97316] hover:bg-slate-50"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-orange-50 text-[#F97316]">
                <Plus className="h-5 w-5" />
              </span>
              <span>
                <span className="block font-bold text-slate-950">
                  Publicar propiedad
                </span>
                <span className="text-sm text-slate-600">
                  Subir una nueva propiedad.
                </span>
              </span>
            </button>

            <button
              type="button"
              onClick={() => navigate("/editar-datos")}
              className="flex items-center gap-3 rounded-lg border border-slate-200 bg-white p-4 text-left shadow-sm transition hover:border-slate-400 hover:bg-slate-50"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-slate-100 text-slate-700">
                <UserRound className="h-5 w-5" />
              </span>
              <span>
                <span className="block font-bold text-slate-950">Mis datos</span>
                <span className="text-sm text-slate-600">
                  Editar nombre, WhatsApp y tipo de usuario.
                </span>
              </span>
            </button>

            <button
              type="button"
              onClick={handleLogout}
              className="flex items-center gap-3 rounded-lg border border-red-100 bg-white p-4 text-left shadow-sm transition hover:bg-red-50"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-red-50 text-red-600">
                <LogOut className="h-5 w-5" />
              </span>
              <span>
                <span className="block font-bold text-red-600">
                  Cerrar sesion
                </span>
                <span className="text-sm text-slate-600">
                  Salir de esta cuenta.
                </span>
              </span>
            </button>
          </div>
        </section>
      </main>
    </>
  );
};

export default MiPerfil;
